module.exports = __webpack_public_path__ + "img/20190629102754719.9eed28c8.png";